import Vue from 'vue'
import VueMultiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.component('v-multiselect', VueMultiSelect)
